import { create } from 'zustand';

type MaintenanceState = {
  enabled: boolean;
  checked: boolean;
  setEnabled: (enabled: boolean) => void;
  setChecked: () => void;
};

export const useMaintenanceStore = create<MaintenanceState>((set) => ({
  enabled: false,
  checked: false,
  setEnabled: (enabled) => set({ enabled, checked: true }),
  setChecked: () => set({ checked: true }),
}));
